export enum ContratoEnum {
	EMITINDO,
	BAIXAR,
	EMITIR,
}
